import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';
import { Image } from 'primereact/image';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';

import MessageBox from '../components/MessageBox.jsx';
import fetchApi from '../lib/fetchApi.js';
import { setBodyPage } from '../lib/functions.js';
import pkg from '../../package.json';

const Home = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showMessageBox, setShowMessageBox] = useState(false);
  const [messageBoxContent, setMessageBoxContent] = useState('');

  useEffect(() => {
    setBodyPage('home');
  }, []);

  const login = async () => {
    setIsLoading(true);
    const response = await fetchApi('/api/v1/user/login', { username, password });
    if (response.state === 1) {
      navigate('/dashboard');
    } else {
      const code = response.error?.[0];
      if (code === 'empty_username_password') setMessageBoxContent('必須輸入用戶名稱及密碼。');
      else if (code === 'incorrect_username_password') setMessageBoxContent('登入名稱或密碼錯誤。');
      else setMessageBoxContent('登入失敗，請稍後再試。');
      setShowMessageBox(true);
    }
    setIsLoading(false);
  };

  return (
    <div className="likkan-login">
      <Card className="likkan-login-card">
        <div className="flex flex-column align-items-center">
          <Image src="/images/likkan-icon.jpg" alt="Image" width="100" />
          <Divider align="center">
            <span>登入系統</span>
          </Divider>
          <div className="likkan-login-form">
            <InputText
              value={username}
              onChange={(e) => setUsername(e.target.value.toLowerCase())}
              placeholder="登入名稱"
            />
            <Password
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              feedback={false}
              placeholder="密碼"
              inputStyle={{ width: '100%' }}
              style={{ width: '100%' }}
            />
            <Button
              label="登入"
              icon="pi pi-sign-in"
              loading={isLoading}
              onClick={login}
              disabled={isLoading}
            />
            <div className="text-sm text-color-secondary text-center mt-2">
              v{pkg.version}
            </div>
          </div>
        </div>
      </Card>
      <MessageBox
        visible={showMessageBox}
        title="登入錯誤"
        content={messageBoxContent}
        type="warning"
        onHide={() => setShowMessageBox(false)}
      />
    </div>
  );
};

export default Home;
